var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header'),_c('div',{staticClass:"not-found-wrap"},[_vm._v("\n      Страница не найдена            \n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }